import _ from 'lodash';
import React from 'react';
import onClickOutside from 'react-onclickoutside';
import * as Styled from './styled';
import SubMenuItem from '../SubMenuItem/SubMenuItem';
import navBarTestIds from '../NavigationMenu.elements';
import Portal from '../../Common/Portal/Portal';
import {
	setMenuToggleHandler,
	toggleMenuOnTab,
	toggleMenuOnShiftTab,
} from '../../../../logic/functions/common/menuDisplayToggle';
import { NavTreeItem } from '../../../../logic/domains/navigationTree.domain';

type SubMenuProps = {
	parentIdentifier: string;
	subpages?: NavTreeItem[];
	onClickOutside(event: any): void;
	onClickInside(event: any): void;
	parentRef: React.ReactInstance | null;
	analyticsIdentifier: string;
	shouldAlignRight?: Function;
};

export class SubMenu extends React.Component<SubMenuProps> {
	constructor(props: any) {
		super(props);
		setMenuToggleHandler(this.props.onClickOutside);
	}

	handleClickOutside = (event: any) => {
		this.props.onClickOutside(event);
	};

	render() {
		const {
			subpages,
			parentRef,
			parentIdentifier,
			shouldAlignRight,
		} = this.props;
		const isRightAligned = shouldAlignRight && shouldAlignRight();
		return (
			<Portal node={document.getElementById(parentIdentifier)}>
				<Styled.ResponsiveContainer
					parentRef={parentRef}
					position={{ left: 0, right: -256, width: 256 }}
					alignment={isRightAligned ? 'right' : 'left'}
					dataId={`${
						navBarTestIds.navSubMenuUlContainer
					}-parent-${parentIdentifier}`}
				>
					<Styled.SubMenuContainer>
						<Styled.Ul
							onClick={(event: any) => this.props.onClickInside(event)}
							onKeyUp={(event: any) => toggleMenuOnTab(event, true)}
							onKeyDown={(event: any) => toggleMenuOnShiftTab(event, true)}
							data-id={navBarTestIds.navSubMenuUlContainer}
						>
							{_.map(subpages, (navItem: NavTreeItem, index: Number) => {
								return (
									// @ts-ignore
									<SubMenuItem
										key={_.snakeCase(navItem.title)}
										title={navItem.title}
										relativePath={navItem.path}
										absolutePath={navItem.url as string}
										tabIndex={index}
										aria-modal="true"
										parentIdentifier={this.props.parentIdentifier}
									/>
								);
							})}
						</Styled.Ul>
					</Styled.SubMenuContainer>
				</Styled.ResponsiveContainer>
			</Portal>
		);
	}
}

export default onClickOutside(SubMenu);
